// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1-6VF","noInteraction":"EventWrapper_noInteraction__Guw9y"};